import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';
import { TButtonTheme } from '@cian/ui-kit/button/types';
import { useSelector } from 'react-redux';

import { AboutRealtorFooter } from '../../components/AboutRealtorFooter';
import { RealtorInfoContainer } from '../RealtorInfoContainer';
import { ErrorModal } from '../../components/ErrorModal';
import { ModalLoader } from '../../components/ModalLoader';
import { realtorInfoApi } from '../../api/realtorInfoApi';
import { selectCurrentRealtor } from '../../selectors/selectCurrentRealtor';
import { ISpecialistCatalogListing } from '../../types/demand/specialistListing';

export interface IAboutRealtorModalContainerProps {
  resetRealtorCardData: () => void;
  handleSelectRealtor: (realtor?: ISpecialistCatalogListing | null) => void;
  handleUnselectRealtor: (realtorId?: string) => void;
  isButtonDisabled: boolean;
  selectedRealtorsId: number[];
}

export const AboutRealtorModalContainer: React.FC<
  React.PropsWithChildren<IAboutRealtorModalContainerProps>
> = props => {
  const { isButtonDisabled, handleSelectRealtor, handleUnselectRealtor, selectedRealtorsId, resetRealtorCardData } =
    props;
  const realtor = useSelector(selectCurrentRealtor) as ISpecialistCatalogListing;
  const getRealtorInfoState = realtorInfoApi.endpoints.getRealtorInfo.useQuery({ cianUserId: realtor.cianUserId });

  const isSelectedRealtor = realtor?.id ? selectedRealtorsId.includes(realtor.id) : false;

  const onSelectInModal = (realtor?: ISpecialistCatalogListing | null) => {
    handleSelectRealtor(realtor);
    resetRealtorCardData();
  };

  const onUnselectInModal = (realtor?: ISpecialistCatalogListing | null) => {
    handleUnselectRealtor(String(realtor?.id));
    resetRealtorCardData();
  };

  const buttonProps = isSelectedRealtor
    ? {
        buttonText: 'Отменить выбор',
        buttonTheme: 'fill_white_primary' as TButtonTheme,
        onButtonClick: () => onUnselectInModal(realtor),
      }
    : {
        buttonText: 'Выбрать',
        buttonTheme: 'fill_secondary' as TButtonTheme,
        onButtonClick: () => onSelectInModal(realtor),
      };

  switch (true) {
    case Boolean(getRealtorInfoState.data && realtor): {
      return (
        <ModalWindow
          fixed={true}
          open={true}
          onClose={resetRealtorCardData}
          width={980}
          height={'100%'}
          maxHeight={708}
          content={<RealtorInfoContainer />}
          footer={<AboutRealtorFooter {...buttonProps} isButtonDisabled={isButtonDisabled} />}
        />
      );
    }
    case getRealtorInfoState.isFetching: {
      return (
        <ModalWindow
          fixed={true}
          open={true}
          onClose={resetRealtorCardData}
          width={980}
          height={'100%'}
          maxHeight={708}
          content={<ModalLoader />}
        />
      );
    }
    case getRealtorInfoState.isError: {
      return <ErrorModal open={true} onClose={resetRealtorCardData} />;
    }
    default:
      return null;
  }
};

AboutRealtorModalContainer.displayName = 'AboutRealtorModalContainer';
